// Mock data for community features
export const mockUsers = [
  {
    id: 1,
    name: "Sharath Sharma",
    username: "sharath.sharma",
    email: "sharath.sharma@gmail.com",
    location: "Mumbai",
    followers: 45,
    following: 32,
    avatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    bio: "A Numismatics & philately enthusiast, with many years of collecting experience. I have a passion for collecting vintage postcards, especially those that showcase beautiful landscapes and historical landmarks.",
    collectionInterests: "Stamps, Coins, Paper Money, Indian Medals",
    totalItemsAdded: 1027,
    joinedDate: "2023-01-15"
  },
  {
    id: 2,
    name: "Kiran Jain",
    username: "kiran.jain",
    email: "kiran.jain@gmail.com",
    location: "Delhi",
    followers: 78,
    following: 56,
    avatar: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    bio: "Ancient coin collector specializing in Gupta period artifacts. Passionate about preserving Indian numismatic heritage.",
    collectionInterests: "Ancient Coins, Artifacts, Historical Items",
    totalItemsAdded: 856,
    joinedDate: "2022-11-20"
  },
  {
    id: 3,
    name: "Aarav Sharma",
    username: "aarav.sharma",
    email: "aarav.sharma@gmail.com",
    location: "Dhanbad",
    followers: 32,
    following: 28,
    avatar: "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    bio: "Heritage preservation enthusiast with focus on ancient Indian coins and stamps.",
    collectionInterests: "Coins, Stamps, Ancient Artifacts",
    totalItemsAdded: 642,
    joinedDate: "2023-03-10"
  },
  {
    id: 4,
    name: "Vijay Sharma",
    username: "vijay.sharma",
    email: "vijay.sharma@gmail.com",
    location: "Bangalore",
    followers: 89,
    following: 67,
    avatar: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    bio: "Collector and researcher of Indian postal history and philatelic materials.",
    collectionInterests: "Stamps, Postal History, Documents",
    totalItemsAdded: 1234,
    joinedDate: "2022-08-05"
  }
];

export const mockCollections = [
  {
    id: 1,
    title: "Regular Mint Wise Vol 1",
    description: "Complete collection of Indian regular mint coins from various periods",
    userId: 3,
    itemCount: 900,
    totalItems: 900,
    progress: 100,
    coverImage: "https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    category: "Coins",
    isPublic: true,
    createdAt: "2023-01-15"
  },
  {
    id: 2,
    title: "Regular Mint Wise Vol 2",
    description: "Second volume of Indian regular mint coin collection",
    userId: 3,
    itemCount: 112,
    totalItems: 560,
    progress: 20,
    coverImage: "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    category: "Coins",
    isPublic: true,
    createdAt: "2023-02-20"
  },
  {
    id: 3,
    title: "Indian Postage Stamps Volume 2",
    description: "Post-independence Indian postage stamps collection",
    userId: 3,
    itemCount: 15,
    totalItems: 340,
    progress: 4.4,
    coverImage: "https://images.pexels.com/photos/6069112/pexels-photo-6069112.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    category: "Stamps",
    isPublic: true,
    createdAt: "2023-03-10"
  },
  {
    id: 4,
    title: "Gupta Period Coins",
    description: "Ancient coins from the Gupta dynasty period (320-550 CE)",
    userId: 2,
    itemCount: 45,
    totalItems: 100,
    progress: 45,
    coverImage: "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    category: "coins",
    isPublic: true,
    createdAt: "2023-01-05"
  }
];

export const mockFeedPosts = [
  {
    id: 1,
    userId: 1,
    userName: "Sharath Sharma",
    userAvatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    userRole: "historian",
    type: "showcase",
    title: "Kumar Gupta I Gold Dinar",
    description: "Rare gold dinar from the reign of Kumar Gupta I, featuring the king on horseback. This coin represents the pinnacle of Gupta numismatic artistry, with intricate details showing the monarch's regalia and the Garuda standard. The reverse depicts the goddess Lakshmi seated on a lotus, symbolizing prosperity and divine favor.",
    images: [
      "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
      "https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop"
    ],
    likes: 124,
    commentCount: 18,
    shares: 12,
    timestamp: "2024-10-14T08:33:00Z",
    category: "coins",
    location: "Pataliputra, Bihar, India 🇮🇳",
    era: "Gupta Empire, 415-455 CE",
    civilization: "Gupta Dynasty",
    heritage: {
      unesco: false,
      protected: true,
      endangered: false
    },
    tags: ["Gupta", "Gold Dinar", "Ancient India", "Numismatics"]
  },
  {
    id: 2,
    userId: 2,
    userName: "Kiran Jain",
    userAvatar: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    userRole: "collector",
    type: "collection",
    title: "Ajanta Cave Paintings Documentation",
    description: "Comprehensive photographic study of the Buddhist cave paintings at Ajanta. These 2nd century BCE to 5th century CE murals depict Jataka tales and showcase the evolution of Indian art across centuries. The paintings reveal sophisticated techniques in perspective, shading, and narrative composition that influenced Asian art for millennia.",
    images: [
      "https://images.pexels.com/photos/3408354/pexels-photo-3408354.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop"
    ],
    likes: 289,
    commentCount: 34,
    shares: 45,
    timestamp: "2024-10-14T06:20:00Z",
    category: "artifacts",
    location: "Ajanta, Maharashtra, India 🇮🇳",
    era: "2nd Century BCE - 5th Century CE",
    civilization: "Buddhist India",
    heritage: {
      unesco: true,
      protected: true,
      endangered: false
    },
    tags: ["UNESCO", "Buddhist Art", "Cave Paintings", "Ancient India"]
  },
  {
    id: 3,
    userId: 4,
    userName: "Vijay Sharma",
    userAvatar: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    userRole: "curator",
    type: "showcase",
    title: "Konark Sun Temple - Architectural Marvel",
    description: "The Konark Sun Temple, built in the 13th century, is designed as a colossal chariot with 24 elaborately carved stone wheels pulled by seven horses. This UNESCO World Heritage site represents the zenith of Kalinga architecture and showcases advanced astronomical knowledge through its precise solar alignments.",
    images: [
      "https://images.pexels.com/photos/3408354/pexels-photo-3408354.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop"
    ],
    likes: 456,
    commentCount: 67,
    shares: 89,
    timestamp: "2024-10-13T15:20:00Z",
    category: "artifacts",
    location: "Konark, Odisha, India 🇮🇳",
    era: "13th Century CE (1250 CE)",
    civilization: "Eastern Ganga Dynasty",
    heritage: {
      unesco: true,
      protected: true,
      endangered: true
    },
    tags: ["UNESCO", "Temple", "Architecture", "Endangered"]
  },
  {
    id: 4,
    userId: 3,
    userName: "Aarav Sharma",
    userAvatar: "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    userRole: "expert",
    type: "showcase",
    title: "Harappan Seal - Indus Valley Civilization",
    description: "Steatite seal featuring the iconic 'unicorn' motif and undeciphered Indus script. These seals were used for trade and administrative purposes, revealing the sophisticated urban culture of the Indus Valley. The precision of carving and standardization across sites demonstrates remarkable technological and organizational capabilities.",
    images: [
      "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop"
    ],
    likes: 234,
    commentCount: 42,
    shares: 28,
    timestamp: "2024-10-13T10:15:00Z",
    category: "artifacts",
    location: "Mohenjo-daro, Sindh, Pakistan 🇵🇰",
    era: "Mature Harappan, 2600-1900 BCE",
    civilization: "Indus Valley Civilization",
    heritage: {
      unesco: true,
      protected: true,
      endangered: false
    },
    tags: ["Harappan", "Indus Valley", "Ancient Seal", "Bronze Age"]
  },
  {
    id: 5,
    userId: 1,
    userName: "Sharath Sharma",
    userAvatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    userRole: "historian",
    type: "collection",
    title: "Chola Bronze Sculptures",
    description: "Exquisite bronze sculpture of Nataraja (Dancing Shiva) from the Chola period. These bronzes represent the pinnacle of Indian metallurgy and artistic expression, with perfect proportions based on ancient texts. The lost-wax casting technique used demonstrates extraordinary technical mastery.",
    images: [
      "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop"
    ],
    likes: 378,
    commentCount: 56,
    shares: 67,
    timestamp: "2024-10-12T14:30:00Z",
    category: "artifacts",
    location: "Thanjavur, Tamil Nadu, India 🇮🇳",
    era: "Chola Dynasty, 10th-11th Century CE",
    civilization: "Chola Empire",
    heritage: {
      unesco: false,
      protected: true,
      endangered: false
    },
    tags: ["Chola", "Bronze", "Nataraja", "Sculpture"]
  },
  {
    id: 6,
    userId: 2,
    userName: "Kiran Jain",
    userAvatar: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    userRole: "collector",
    type: "showcase",
    title: "Mughal Miniature Painting",
    description: "Rare Mughal miniature depicting Emperor Akbar's court. These paintings blend Persian, Indian, and European artistic traditions, showcasing the cultural synthesis of the Mughal era. The intricate details and vibrant natural pigments have survived centuries, demonstrating advanced preservation techniques.",
    images: [
      "https://images.pexels.com/photos/6069112/pexels-photo-6069112.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop"
    ],
    likes: 198,
    commentCount: 29,
    shares: 34,
    timestamp: "2024-10-12T09:45:00Z",
    category: "books",
    location: "Agra, Uttar Pradesh, India 🇮🇳",
    era: "Mughal Empire, 16th Century CE",
    civilization: "Mughal Dynasty",
    heritage: {
      unesco: false,
      protected: true,
      endangered: false
    },
    tags: ["Mughal", "Miniature", "Painting", "Akbar"]
  }
];

export const mockShowcases = [
  {
    id: 1,
    title: "KUMAR GUPTA I",
    description: "Gupta Period Coins. 320BC - 450AD. AE Fraction denomination, made in Lead & Bronze. Primitive Money (300-100 BC), Rigvedic Period, Gold Pin, Pin with deity symbol (Lord Vishnu?), ancient jewellery used as barter, ornaments with decoration, 0.75g, 5.14x14.4mm, good quality, about extremely fine, Very Rare.",
    userId: 1,
    images: [
      "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop"
    ],
    likes: 24,
    comments: [
      {
        id: 1,
        userId: 4,
        text: "Great showcase Aarav. I've been wanting to build something like this!",
        timestamp: "2024-10-14T09:15:00Z"
      }
    ],
    shares: 5,
    createdAt: "2024-10-14T08:33:00Z",
    category: "coins",
    tags: ["gupta", "ancient", "coins", "rare"],
    isPublic: true
  },
  {
    id: 2,
    title: "GANDHIYA COINS -1",
    description: "Found in many regions of North India, mainly near Gujarat. Silver type metal - 'DARCHAM'. These coins represent an important period in Indian numismatic history.",
    userId: 1,
    images: [
      "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
      "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop"
    ],
    likes: 18,
    comments: [],
    shares: 3,
    createdAt: "2024-10-13T14:20:00Z",
    category: "coins",
    tags: ["gandhiya", "silver", "gujarat", "darcham"],
    isPublic: true
  },
  {
    id: 3,
    title: "Mughal Era Silver Coins",
    description: "Rare collection of Mughal period silver coins featuring intricate calligraphy and royal seals.",
    userId: 2,
    images: [
      "https://images.pexels.com/photos/8919564/pexels-photo-8919564.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop"
    ],
    likes: 32,
    comments: [],
    shares: 8,
    createdAt: "2024-10-13T14:20:00Z",
    category: "coins",
    tags: ["mughal", "silver", "medieval"],
    isPublic: true
  }
];

export const mockAwards = [
  {
    id: 1,
    title: "The Philatelic Gem Award",
    description: "Recognizing excellence in philately craftsmanship and innovation, The Philatelic Gem Award celebrates the finest achievements in stamp design and production.",
    image: "https://images.pexels.com/photos/6069112/pexels-photo-6069112.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    awardedTo: 3,
    awardedDate: "2024-09-15",
    category: "Philately",
    level: "Gold"
  },
  {
    id: 2,
    title: "Heritage Preservation Excellence",
    description: "Awarded for outstanding contribution to preserving and documenting cultural heritage through numismatic collections.",
    image: "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    awardedTo: 1,
    awardedDate: "2024-08-20",
    category: "Heritage",
    level: "Platinum"
  },
  {
    id: 3,
    title: "Community Contributor",
    description: "Recognizing active participation and valuable contributions to the collector community.",
    image: "https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    awardedTo: 2,
    awardedDate: "2024-07-10",
    category: "Community",
    level: "Silver"
  }
];

export const mockChallenges = [
  {
    id: 1,
    title: "Regular Mint Wise Vol 1",
    description: "Complete the first volume of regular mint wise Indian coins",
    participants: 156,
    endDate: "2024-12-31",
    prize: "Gold Badge + Featured Collection",
    difficulty: "Intermediate",
    category: "Coins",
    progress: {
      userId: 3,
      completed: 900,
      total: 900,
      rank: 1
    }
  },
  {
    id: 2,
    title: "Regular Mint Wise Vol 2",
    description: "Build the second volume collection with 560 unique pieces",
    participants: 89,
    endDate: "2025-06-30",
    prize: "Silver Badge + Community Recognition",
    difficulty: "Advanced",
    category: "Coins",
    progress: {
      userId: 3,
      completed: 112,
      total: 560,
      rank: 3
    }
  },
  {
    id: 3,
    title: "Indian Postage Stamps Volume 2",
    description: "Collect post-independence Indian stamps",
    participants: 234,
    endDate: "2025-03-15",
    prize: "Bronze Badge + Showcase Feature",
    difficulty: "Beginner",
    category: "Stamps",
    progress: {
      userId: 3,
      completed: 15,
      total: 340,
      rank: 8
    }
  }
];

export const mockLeaderboard = [
  { userId: 3, rank: 1, points: 2847, badge: "Gold" },
  { userId: 1, rank: 2, points: 2156, badge: "Silver" },
  { userId: 2, rank: 3, points: 1923, badge: "Bronze" },
  { userId: 4, rank: 4, points: 1654, badge: "Bronze" }
];

export const mockComments = [
  {
    id: 1,
    postId: 1,
    userId: 4,
    text: "Amazing collection! The detail on these coins is incredible.",
    timestamp: "2024-10-14T09:15:00Z",
    likes: 3
  },
  {
    id: 2,
    postId: 1,
    userId: 2,
    text: "I have a similar piece from the same period. Would love to compare notes!",
    timestamp: "2024-10-14T10:30:00Z",
    likes: 1
  },
  {
    id: 3,
    postId: 3,
    userId: 1,
    text: "Congratulations on completing the collection! That's quite an achievement.",
    timestamp: "2024-10-13T16:45:00Z",
    likes: 5
  }
];